module.exports = __webpack_public_path__ + "img/list50.19f94d89.jpeg";